import { atom } from 'jotai';

export type TemplateForDeletion = { id: string; name: string };

export const selectedTemplateForDeletionAtom = atom<TemplateForDeletion | null>(null);

export const showTemplateDeletionConfirmModalAtom = atom<boolean>(false);
